query bricksProducts($query: String!, $countryCode: CountryCode!)
@inContext(country: $countryCode) {
  products(first: 100, query: $query) {
    nodes {
      variants(first: 100) {
        nodes {
          id
          sku
          selectedOptions {
            name
            value
          }
          price {
            amount
            currencyCode
          }
        }
      }
    }
  }
}
